/**
 * Utility functions for handling brand asset operations
 * Includes SVG fetching, clipboard copying, and asset downloading
 */

/**
 * Fetches an SVG file as a string from the public directory
 * @param path - Path to the SVG file (relative to public directory)
 * @returns Promise containing the SVG content as a string
 * @throws Error if the fetch fails
 */
export async function fetchSVGAsString(path: string): Promise<string> {
  try {
    const response = await fetch(path);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const svgText = await response.text();
    return svgText;
  } catch (error) {
    console.error('Failed to fetch SVG:', error);
    throw error;
  }
}

/**
 * Copies SVG code to the clipboard
 * @param svgPath - Path to the SVG file (relative to public directory)
 * @param assetName - Name of the asset for error messages
 * @throws Error if clipboard operation fails
 */
export async function copySVGToClipboard(
  svgPath: string,
  assetName: string
): Promise<void> {
  try {
    const svgCode = await fetchSVGAsString(svgPath);
    await navigator.clipboard.writeText(svgCode);
  } catch (error) {
    console.error(`Failed to copy ${assetName} to clipboard:`, error);
    throw error;
  }
}

/**
 * Downloads the brand assets ZIP file from Supabase storage
 */
export function downloadBrandAssets(): void {
  try {
    const link = document.createElement('a');
    link.href =
      'https://rrmhxzaxghiovfqqggfv.supabase.co/storage/v1/object/public/WCD%20Brand%20Assets/WCD-Brand-Assets.zip';
    link.download = 'WCD-Brand-Assets.zip';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Failed to download brand assets:', error);
    throw error;
  }
}
